var path = 'app/components/common/forms/templates/row.html';
var html = "<div class=\"row\"><formly-transclude></formly-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/row.html
// module id = 189
// module chunks = 0